const contactTextByLang: Record<string, string> = {
	en: 'For questions or to make changes to your appointment, please reach out to the district office at',
	es: 'Para preguntas o para hacer cambios en su cita, comuníquese con la oficina del distrito al',
	ru: 'По вопросам или для изменения вашей встречи свяжитесь с офисом округа по номеру',
	uk: 'Для питань або внесення змін до вашої зустрічі звертайтесь до офісу округу за номером',
	vi: 'Để hỏi hoặc thay đổi cuộc hẹn của bạn, vui lòng liên hệ văn phòng quận tại',
	zh: '如有问题或需更改预约，请联系学区办公室：',
	ar: 'للاستفسارات أو لتغيير موعدك، يرجى التواصل مع مكتب المنطقة على الرقم',
};

const formatContactInfo = (districtContact: string, languageCode: string) => {
	let digits = districtContact.replace(/\D/g, '');

	if (digits.length > 10 && digits.startsWith('1')) {
		digits = digits.slice(1);
	}

	const formattedNumber = `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;

	return `\n${contactTextByLang[languageCode]} ${formattedNumber}|tel:${digits}.`;
};

export const SmsTemplates = {
	surveyLink: {
		en: (name: string, district: string, link: string) =>
			`Hi ${name}. Thanks for participating in an engagement at ${district}. Please let us know how we're doing. Complete the following survey: ${link}`,
		es: (name: string, district: string, link: string) =>
			`Hola ${name}! Gracias por participar en un compromiso en ${district}. Por favor, háganos saber cómo lo estamos haciendo. Complete la siguiente encuesta: ${link}`,
		ru: (name: string, district: string, link: string) =>
			`Привет ${name}! Спасибо за участие в мероприятии в ${district}. Пожалуйста, дайте нам знать, как мы справляемся. Заполните следующий опрос: ${link}`,
		uk: (name: string, district: string, link: string) =>
			`Привіт ${name}. Дякуємо за участь у заході в  ${district}. Будь ласка, дайте нам знати, як ми працюємо. Заповніть наступне опитування: ${link}`,
		vi: (name: string, district: string, link: string) =>
			`Xin chào ${name}.Cảm ơn bạn đã tham gia vào một sự kiện tại  ${district}. Vui lòng cho chúng tôi biết chúng tôi đang làm như thế nào. Hoàn thành khảo sát sau: ${link}`,
		zh: (name: string, district: string, link: string) =>
			`你好 ${name}！感谢您参与 ${district} 的活动。请告诉我们我们的表现如何。请完成以下调查：${link}`,
		ar: (name: string, district: string, link: string) =>
			`مرحبًا ${name}! شكرًا لمشاركتك في فعالية في ${district}. يرجى إخبارنا كيف نقوم بعملنا. أكمل الاستبيان التالي: ${link}`,
	},
	appointmentReminder: {
		en: (appointmentTime: string, appointmentSchool: string, providerFullName: string, districtContact?: string) => {
			let text = `Reminder: you have an appointment tomorrow at ${appointmentTime} at ${appointmentSchool}. Your interpreter will be ${providerFullName}.`;

			if (districtContact) {
				text += formatContactInfo(districtContact, 'en');
			}

			return text;
		},
		es: (appointmentTime: string, appointmentSchool: string, providerFullName: string, districtContact?: string) => {
			let text = `Recordatorio: tienes una cita mañana a las ${appointmentTime} en ${appointmentSchool}. Tu intérprete será ${providerFullName}.`;

			if (districtContact) {
				text += formatContactInfo(districtContact, 'es');
			}

			return text;
		},
		ru: (appointmentTime: string, appointmentSchool: string, providerFullName: string, districtContact?: string) => {
			let text = `Напоминание: у Вас назначена встреча завтра в ${appointmentTime} в ${appointmentSchool}. Ваш переводчик – ${providerFullName}.`;

			if (districtContact) {
				text += formatContactInfo(districtContact, 'ru');
			}

			return text;
		},
		uk: (appointmentTime: string, appointmentSchool: string, providerFullName: string, districtContact?: string) => {
			let text = `Нагадування: у Вас запланована зустріч завтра о ${appointmentTime} у ${appointmentSchool}. Ваш перекладач – ${providerFullName}.`;

			if (districtContact) {
				text += formatContactInfo(districtContact, 'uk');
			}

			return text;
		},
		vi: (appointmentTime: string, appointmentSchool: string, providerFullName: string, districtContact?: string) => {
			let text = `Nhắc nhở: bạn có một cuộc hẹn vào ngày mai lúc ${appointmentTime} tại ${appointmentSchool}. Phiên dịch viên của bạn sẽ là ${providerFullName}.`;

			if (districtContact) {
				text += formatContactInfo(districtContact, 'vi');
			}

			return text;
		},
		zh: (appointmentTime: string, appointmentSchool: string, providerFullName: string, districtContact?: string) => {
			let text = `提醒：您明天在 ${appointmentTime} 于 ${appointmentSchool} 有一个预约。您的口译员是 ${providerFullName}。`;

			if (districtContact) {
				text += formatContactInfo(districtContact, 'zn');
			}

			return text;
		},
		ar: (appointmentTime: string, appointmentSchool: string, providerFullName: string, districtContact?: string) => {
			let text = `تذكير: لديك موعد غدًا في ${appointmentTime} في ${appointmentSchool}. سيكون مترجمك ${providerFullName}.`;

			if (districtContact) {
				text += formatContactInfo(districtContact, 'ar');
			}

			return text;
		},
	},
	updatedAppointmentReminder: {
		en: (appointmentTime: string, appointmentSchool: string, providerFullName: string, districtContact?: string) => {
			let text = `Details of your appointment at ${appointmentSchool} were changed. Date: ${appointmentTime}. Your interpreter - ${providerFullName}.`;

			if (districtContact) {
				text += formatContactInfo(districtContact, 'en');
			}

			return text;
		},
		es: (appointmentTime: string, appointmentSchool: string, providerFullName: string, districtContact?: string) => {
			let text = `Los detalles de su cita en ${appointmentSchool} han sido modificados. Fecha: ${appointmentTime}. Su intérprete: ${providerFullName}.`;

			if (districtContact) {
				text += formatContactInfo(districtContact, 'es');
			}

			return text;
		},
		ru: (appointmentTime: string, appointmentSchool: string, providerFullName: string, districtContact?: string) => {
			let text = `Детали вашей встречи в ${appointmentSchool} были изменены. Дата: ${appointmentTime}. Ваш переводчик — ${providerFullName}.`;

			if (districtContact) {
				text += formatContactInfo(districtContact, 'ru');
			}

			return text;
		},
		uk: (appointmentTime: string, appointmentSchool: string, providerFullName: string, districtContact?: string) => {
			let text = `Деталі вашої зустрічі в ${appointmentSchool} були змінені. Дата: ${appointmentTime}. Ваш перекладач – ${providerFullName}.`;

			if (districtContact) {
				text += formatContactInfo(districtContact, 'uk');
			}

			return text;
		},
		vi: (appointmentTime: string, appointmentSchool: string, providerFullName: string, districtContact?: string) => {
			let text = `Thông tin cuộc hẹn của bạn tại ${appointmentSchool} đã được thay đổi. Ngày: ${appointmentTime}. Người phiên dịch của bạn – ${providerFullName}.`;

			if (districtContact) {
				text += formatContactInfo(districtContact, 'vi');
			}

			return text;
		},
		zh: (appointmentTime: string, appointmentSchool: string, providerFullName: string, districtContact?: string) => {
			let text = `您在 ${appointmentSchool} 的预约详情已更改。日期：${appointmentTime}。您的翻译员：${providerFullName}。`;

			if (districtContact) {
				text += formatContactInfo(districtContact, 'zn');
			}

			return text;
		},
		ar: (appointmentTime: string, appointmentSchool: string, providerFullName: string, districtContact?: string) => {
			let text = `تم تغيير تفاصيل موعدك في ${appointmentSchool}. التاريخ: ${appointmentTime}. مترجمك - ${providerFullName}.`;

			if (districtContact) {
				text += formatContactInfo(districtContact, 'ar');
			}

			return text;
		},
	},
};
